import { PromotionModel } from "@/models";

export const promotionMock: PromotionModel = {
  _id: "promo12345",
  idPick: "pick001",
  name: "Promo Spéciale Printemps",
  description: "Réduction exceptionnelle pour fêter le printemps",
  conditions: "Valable du 1er au 30 avril, uniquement en ligne",
  storeId: "store789",
  startDate: new Date("2025-04-01T00:00:00.000Z"),
  endDate: new Date("2025-04-30T23:59:59.000Z"),
  startTime: "08:00",
  endTime: "22:00",
  priority: 1,
  containsAllPartnumber: false,
  applyOnItems: true,
  applyOnItemsCP: false,
  addRibbonAdOnItem: true,
  ribbonAd: "Offre Printemps 🌸",
  applyPercentageOnPriceItem: true,
  descriptionForModale: "Profitez de 20% sur une sélection d’articles pendant tout le mois d’avril.",
  urlForModale: "https://example.com/promo-printemps",
  promotionType: "PROMOTION_CODE",
  categoriesIncl: ["vin-rouge", "champagne"],
  categoriesExcl: ["accessoires"],
  segmentsIncl: ["premium"],
  segmentsExcl: ["pro"],
  attributesIncl: [
    { valueId: "attr1", name: "bio" },
    { valueId: "attr2", name: "sans sulfites" }
  ],
  attributesExcl: [
    { valueId: "attr3", name: "millésime 1990" }
  ],
  postalCodesListIncl: ["75001", "75002"],
  postalCodesListExcl: ["13001"],
  discountType: "PERCENTAGE_DISCOUNT",
  minimumCart: 50,
  minimumItems: 2,
  minimumNbEquivBtl: 3,
  amount: 0,
  percentage: 20,
  offeredItems: ["item123", "item456"],
  offeredManyItems: [
    {
      _id: "pack001",
      name: "Pack Découverte",
      partnumbers: ["pn001", "pn002"]
    }
  ],
  promoLevel: [1, 2, 3],
  promoAmountByLevel: [5, 10, 15],
  maxDiscount: 30,
  isCodeUnique: false,
  nbUsesCode: 100,
  nbUsesCustomer: 1,
  nbUsed: 45,
  promoCodesList: [
    {
      _id: "code001",
      storeId: "store789",
      codePromo: "SPRING20",
      email: "client@example.com",
      usedDate: new Date("2025-04-05T10:00:00.000Z"),
      used: true,
      nbUsed: 1
    }
  ],
  nbCodes: 1000,
  prefix: "SPRING",
  suffix: "2025",
  nbChars: 6,
  couponsList: [],
  onTotalOrder: false,
  isCombinable: true,
  mustBeFirstOrder: false,
  discountApply: 20,
  promotionByPtListPartnumber: ["pt001", "pt002"],
  promotionByPtListPercent: [10, 15],
  promotionByPtListValue: [5, 8],
  shippingsExcl: ["express", "point-relais"],
  creatorEmail: "admin@promo.com",
  promoSap: false,
  offeredItemsByLevel: ["item123", "item789"]
};

export default promotionMock;
